import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const confidenceCollaborationPlugin = createPlugin({
  id: 'confidence-collaboration',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const ConfidenceCollaborativeDocumentPage =
  confidenceCollaborationPlugin.provide(
    createRoutableExtension({
      name: 'ConfidenceCollaborativeDocumentPage',
      component: () =>
        import(
          /* webpackChunkName: "confidence-collaboration", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
      mountPoint: rootRouteRef,
    }),
  );
